import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import Departments from './Departments';

const Settings = () => {
  const [settings, setSettings] = useState({
    officeLatitude: '',
    officeLongitude: '',
    geofenceRadiusMeters: '',
    workingHoursStart: '',
    workingHoursEnd: '',
    halfDayMinHours: '',
    fullDayMinHours: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await api.get('/settings');
      if (res.data) {
        setSettings(res.data);
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to load settings.' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage({ type: '', text: '' });
    
    try {
      await api.put('/settings', settings);
      setMessage({ type: 'success', text: 'Settings updated successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Failed to update settings.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="p-6">Loading settings...</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">System Settings</h1>

      {message.text && (
        <div className={`mb-6 p-4 rounded-md ${message.type === 'error' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
          {message.text}
        </div>
      )}

      <Departments />

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6">
        
        <div className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-4">Geofencing & Location</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Office Latitude</label>
              <input 
                type="number" step="any" required
                name="officeLatitude"
                value={settings.officeLatitude}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Office Longitude</label>
              <input 
                type="number" step="any" required
                name="officeLongitude"
                value={settings.officeLongitude}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Geofence Radius (Meters)</label>
              <input 
                type="number" required
                name="geofenceRadiusMeters"
                value={settings.geofenceRadiusMeters}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Maximum allowed distance from office coordinates to clock in.</p>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-4">Attendance Thresholds & Working Hours</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Working Hours Start (Late Arrival) (HH:MM)</label>
              <input 
                type="time" required
                name="workingHoursStart"
                value={settings.workingHoursStart}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Clocking in after this time is marked as Late.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Working Hours End (Early Leaving) (HH:MM)</label>
              <input 
                type="time" required
                name="workingHoursEnd"
                value={settings.workingHoursEnd}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Clocking out before this time is marked as Early Leaving.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Half Day Minimum Hours</label>
              <input 
                type="number" step="any" required
                name="halfDayMinHours"
                value={settings.halfDayMinHours}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Minimum hours required for a Half Day.</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Day Minimum Hours</label>
              <input 
                type="number" step="any" required
                name="fullDayMinHours"
                value={settings.fullDayMinHours}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Minimum hours required for a Full Day (PRESENT).</p>
            </div>
          </div>
        </div>

        <div className="flex justify-end pt-4 border-t">
          <button 
            type="submit" 
            disabled={saving}
            className={`px-6 py-2 rounded-lg text-white font-medium ${saving ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
          >
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Settings;
